import type { ShopRoleBriefVO } from "@/api/employees/type";

/**
 * 取角色唯一键（角色名称，供穿梭与保存）
 * @param role 角色简要信息
 */
export function getRoleKey(role: ShopRoleBriefVO): string | null {
  const name = role.roleName?.trim();
  return name || null;
}

/**
 * 从列表中提取有效角色名称
 * @param list 角色简要列表
 */
export function collectRoleNames(list: ShopRoleBriefVO[]): string[] {
  return list.map((item) => getRoleKey(item)).filter((name): name is string => Boolean(name));
}

/**
 * 按角色名 / 系统端关键词过滤（仅作用于传入的本侧列表）
 * @param roles 本侧角色列表
 * @param keyword 搜索关键词
 */
export function filterRolesByKeyword(roles: ShopRoleBriefVO[], keyword: string) {
  const query = keyword.trim().toLowerCase();
  if (!query) return roles;
  return roles.filter((role) => {
    const haystack = [role.roleName, ...(role.systemTypeNames ?? [])].join(" ").toLowerCase();
    return haystack.includes(query);
  });
}

/**
 * 比较初始与当前右侧角色名，判断是否有未保存变更
 * @param initialNames 打开时已分配角色名
 * @param currentNames 当前右侧角色名
 */
export function isRoleSelectionDirty(initialNames: string[], currentNames: string[]) {
  if (initialNames.length !== currentNames.length) return true;
  const initialSet = new Set(initialNames);
  return currentNames.some((name) => !initialSet.has(name));
}
